<template>
  <div class="aco-info-box">
    <b-col class="aco-details">
      <b-row class="aco-details-row">
        <b-col>
          <b-row>
            <b-col><h5>{{ $t('scheduledJobs') }}</h5></b-col>
          </b-row>
          <b-row>
            <b-col>{{ $t('description') }}</b-col>
          </b-row>
          <hr>
          <div v-for="job in jobs" v-bind:key="job.job">
            <b-row>
              <b-col>
                <b>{{ $t('name.' + job.job) }} ({{ job.job }})</b>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                {{ $t('lastSuccessful') }}
              </b-col>
              <b-col col="2">
                {{ $t('started') }}: {{ job.lastSuccessfulStarted }}
              </b-col>
              <b-col col="2">
                {{ $t('finished') }}: {{ job.lastSuccessfulFinished }}
              </b-col>
              <b-col md="6">
                {{ $t('message') }}: {{ job.lastSuccessfulRunMessage }}
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                {{ $t('lastFailed') }}
              </b-col>
              <b-col col="2">
                {{ $t('started') }}: {{ job.lastFailedStarted }}
              </b-col>
              <b-col col="2">
                {{ $t('finished') }}: {{ job.lastFailedFinished }}
              </b-col>
              <b-col md="6">
                {{ $t('message') }}: {{ job.lastFailedRunMessage }}
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col>
                <b-button
                  size="sm"
                  type="reset"
                  class="float-lg-left"
                  :disabled=disableResetButton(job.lastFailedStarted)
                  @click="resetFailureStatus(job.job)"
                >
                  {{ $t('reset') }}
                </b-button>
              </b-col>
            </b-row>
            <hr>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SchedulingService from "@/services/SchedulingJobService";

  export default {
    computed: {
      ...mapGetters('scheduling', ['jobs']),
      ...mapGetters('languageStore', ['langCode'])
    },
    created: function () {
      this.$store.dispatch('scheduling/getJobs')
    },
    methods: {
      resetFailureStatus (job) {
        SchedulingService.deleteFailureStatus(job)
          .then(() => {
            this.$store.dispatch('scheduling/getJobs')
          })
      },
      disableResetButton(lastFailedStarted) {
        return lastFailedStarted === null;
      },
    },

    i18n: {
      messages: {
        en: {
          'description': 'This page shows the results of the last successful and last failed run of each scheduled job.',
          'lastSuccessful': 'Last successful run',
          'lastFailed': 'Last failed run',
          'started': 'Started',
          'finished': 'Finished',
          'name.POLL_ORDERS': 'Poll new and updated orders',
          'name.UNIBOK_PUSH': 'Unibok export',
          'name.USER_EXPIRY': 'Expire users',
          'name.USER_EXPIRY_WARNING': 'Mail user expiry warnings',
          'name.VALIDATE_PRODUCTS': 'Validate products',
          'name.DELETE_EMPTY_GROUPS': 'Delete empty groups',
          'name.DELETE_OLD_EVENTS': 'Delete old events',
          'name.POLL_NSR_ORGANIZATIONS': 'Poll NSR organizations',
          'name.PROCESS_BIBLIO_FILES': 'Process Biblio ONIX files',
          'name.DELETE_OLD_BIBLIO_FILES': 'Delete old Biblio ONIX files',
          'name.DELETE_INCOMPLETE_USERS': 'Delete incomplete users',
          'name.DELETE_EXPIRED_NOTIFICATIONS': 'Delete expired notifications'
        },
        nb: {
          'description': 'Denne siden viser resultat av siste vellykkede og siste feilede kjøring av en jobb.',
          'lastSuccessful': 'Siste vellykede kjøring',
          'lastFailed': 'Siste feilede kjøring',
          'started': 'Startet',
          'finished': 'Ferdig',
          'name.POLL_ORDERS': 'Hent nye og oppdaterte ordre',
          'name.UNIBOK_PUSH': 'Unibok eksport',
          'name.USER_EXPIRY': 'Sletting/deaktivering av brukere',
          'name.USER_EXPIRY_WARNING': 'Varsling om sletting av brukere',
          'name.VALIDATE_PRODUCTS': 'Valider produkter',
          'name.DELETE_EMPTY_GROUPS': 'Slett tomme grupper',
          'name.DELETE_OLD_EVENTS': 'Slett gamle hendelser',
          'name.POLL_NSR_ORGANIZATIONS': 'Oppdater NSR-organisasjoner',
          'name.PROCESS_BIBLIO_FILES': 'Behandle Biblio ONIX filer',
          'name.DELETE_OLD_BIBLIO_FILES': 'Slett gamle Biblio ONIX filer',
          'name.DELETE_INCOMPLETE_USERS': 'Slett uferdige brukere',
          'name.DELETE_EXPIRED_NOTIFICATIONS': 'Slett varsler som har utgått'
        }
      }
    }
  }
</script>
